import { superValidate } from 'sveltekit-superforms';
import { zod } from 'sveltekit-superforms/adapters';
import { formSchema } from './schema';

export async function load() {
  return {
    // @ts-ignore - Type mismatch between zod and sveltekit-superforms types
    form: await superValidate(zod(formSchema))
  };
}
